import { useState, useEffect } from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const Tooltip = ({ text }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleInteraction = () => {
    if (isMobile) {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 3000);
    }
  };

  return (
    // <div className="relative flex items-center">
    //   <InformationCircleIcon
    //     data-tooltip-id="tooltip"
    //     data-tooltip-content={text}
    //     className="h-5 w-5 text-gray-500 hover:text-gray-700 cursor-pointer"
    //     onClick={handleInteraction}
    //     onMouseEnter={() => !isMobile && setShowTooltip(true)}
    //     onMouseLeave={() => !isMobile && setShowTooltip(false)}
    //   />
    //   <ReactTooltip
    //     id="tooltip"
    //     place="top"
    //     effect="solid"
    //     clickable={isMobile}
    //     isOpen={showTooltip}
    //   />
    // </div>
    <div className="relative flex items-center">
      <InformationCircleIcon
        data-tooltip-id="tooltip"
        data-tooltip-content={text}
        className="h-5 w-5 text-green-500 hover:text-green-700 cursor-pointer"
        onClick={handleInteraction}
        onMouseEnter={() => !isMobile && setShowTooltip(true)}
        onMouseLeave={() => !isMobile && setShowTooltip(false)}
      />
      <ReactTooltip
        id="tooltip"
        place="top"
        effect="solid"
        clickable={isMobile}
        isOpen={showTooltip}
        className="tooltip-custom z-50 max-w-xs sm:max-w-md md:max-w-lg xl:max-w-xl break-words text-sm sm:text-base"
      />
    </div>
  );
};

export default Tooltip;
